import React, { useState, useEffect } from "react";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/company";

export default function FloatingButtons() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed left-6 bottom-6 z-40 flex flex-col gap-3 transition-all duration-500 ${
        visible ? "translate-x-0 opacity-100" : "-translate-x-24 opacity-0 pointer-events-none"
      }`}
      data-testid="floating-buttons"
    >
      <a
        href={`https://wa.me/${CONTACT.whatsapp}?text=Hola%20Yohaly%2C%20me%20gustar%C3%ADa%20agendar%20una%20consulta`}
        target="_blank"
        rel="noreferrer"
        className="group flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#128C7E] text-white shadow-2xl hover:scale-105 transition-all relative"
        aria-label="WhatsApp"
        data-testid="float-whatsapp"
      >
        <MessageCircle size={24} strokeWidth={1.75} />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25"></span>
        <span className="absolute left-full ml-3 whitespace-nowrap bg-[#0f172a] text-white text-xs font-medium px-2.5 py-1.5 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Escríbenos
        </span>
      </a>
      <a
        href={`tel:${CONTACT.phone1Tel}`}
        className="group flex items-center justify-center h-14 w-14 rounded-full bg-[#0B2D5C] hover:bg-[#081F42] text-white shadow-2xl hover:scale-105 transition-all"
        aria-label="Llamar"
        data-testid="float-call"
      >
        <Phone size={22} strokeWidth={1.75} />
        <span className="absolute left-full ml-3 whitespace-nowrap bg-[#0f172a] text-white text-xs font-medium px-2.5 py-1.5 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Llámanos
        </span>
      </a>
    </div>
  );
}
